import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Navbar from './header/Navbar'
import Banner from './banner/Banner'
import Footer from './footer/Footer'
import Ourvision from './vision/Ourvision'
import Verified from './verified/Verified'
import Join from './join/Join'
import How from './how/How'

const Landing = () => {
  const location = useLocation()

  useEffect(() => {
    const section = location.hash && document.getElementById(location.hash.slice(1))
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' })
    } else {
      window.scrollTo(0, 0)
    }
  }, [location.hash])

  return (
    <>
    <div 
    className="overflow-hidden"
    >
      <Navbar />
      <Banner />
      <Ourvision />
      <How />
      <Verified />
      <Join />
      <Footer />
      </div>
    </>
  )
}

export default Landing
